import React, { useEffect } from 'react';

import { Button, Container, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { useRedirectResultStyles } from './styles';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';

export default () => {
  const classes = useRedirectResultStyles();
  const history = useHistory();

  useEffect(() => {
    new LogService().create({
      action: ACTIONS.PAYMENT_FAILED,
    });
  }, []);

  return (
    <Container className={classes.container}>
      <Container>
        <Typography variant="h6" className={classes.title}>
          Your payment was unsuccessful
        </Typography>
      </Container>
      <Container className={classes.container1} style={{ width: '32%' }}>
        <Typography variant="subtitle1" className={classes.subtitle}>
          Something went wrong when trying to process your payment. Please contact support or alternatively retry with another payment method.
        </Typography>
      </Container>
      <Container className={classes.container2}>
        <Button variant="contained" color="primary" onClick={() => history.push('/storage-plans')}>
          Back to plans
        </Button>
      </Container>
    </Container>
  );
};
